import styled from 'styled-components';

export const StyledNewRewards = styled.div`
  &.rewards {
    .page-title {
      font-size: 26px;
      span + span {
        margin: 0 5px;
      }
      .highlighted {
        color: ${props => props.theme.main};
        text-transform: capitalize;
      }
    }
    .rewards-stats {
      display: flex;
      align-items: stretch;
      justify-content: space-between;
      margin-top: 50px;
    }
    .rewards-block {
      flex: 1 1 0;
      position: relative;
      padding: 30px 40px;
      box-shadow: 0 5px 34px rgba(89, 102, 137, .05);
      border-radius: 28px;
      background: #fff;
      overflow: hidden;
      .block-bg {
        position: absolute;
        top: -20px;
        left: 50%;
        width: 60%;
        transform: translateX(-50%);
        z-index: 0;
      }
      & + .rewards-block {
        margin-inline-start: 40px;
      }
      &.prizes {
        margin-top: 40px;
        padding: 30px 15px;
        .block-title {
          width: 100%;
          align-self: flex-start;
          padding: 0 25px 15px 0;
        }
        .list {
          direction: ${({ ltr }) => ltr ? 'ltr' : 'rtl'};
          display: flex;
          flex-wrap: wrap;
          padding: 15px 20px 0;
          li, li:not(:last-child) {
            justify-content: flex-start;
            align-items: stretch;
            width: 50%;
            margin-bottom: 40px;
          }
        }
        .collect {
          align-self: flex-start;
          padding-right: 35px;
          margin-top: 20px;
        }
      }
    }
    .total {
      font-size: 45px;
      color: ${props => props.theme.main};
    }
    .next-prize {
      max-width: 250px;
      text-align: center;
      .amount {
        color: ${props => props.theme.main};
        font-weight: bold;
      }
    }
    .gift-logo {
      margin-bottom: 15px;
    }
    .list-headers {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 10px 0;
      div {
        margin-left: -20px;
      }
      span {
        font-size: 21px;
        font-weight: bold;
      }
    }
    .block-wrap {
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      height: 100%;
      z-index: 1;
      &.cost {
        h3 {
          align-self: flex-start;
          width: 100%;
          padding-bottom: 20px;
          border-bottom: 1px solid ${props => props.theme.borderLight};
          display: flex;
          justify-content: space-between;

          .info {
            cursor: pointer;
          }
        }
        .cost {
          font-weight: bold;
        }
      }
      h3 {
        font-size: 24px;
        font-weight: bold;
      }
      .list {
        width: 100%;
        li {
          display: flex;
          align-items: center;
          justify-content: space-between;
          font-size: 18px;
          &:not(:last-child) {
            margin-bottom: 20px;
          }
          .name{
            text-transform: uppercase;
          }
        }
      }
    }
    .scroll-track {
      background: #f2f2f2 !important;
    }
  }
  .visual {
    position: relative;
    width: 180px;
    height: 180px;  
    padding: 10px;
    border: 1px solid transparent;
    box-shadow: 4px 4px 14px rgba(89, 102, 137, .35);
    border-radius: 22px;
    &.selected {
      border-color: #6C90FF;
    }
    &-wrap, img {
      border-radius: 15px;
    }
    img {
      width: 120px;
    }
    &-wrap {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
      width: 100%;
      background: #F2F2F2;
    }
    .image-gallery-right-nav {
      right: -25px;
    }
    .image-gallery-left-nav {
      left: -25px;
    }
  }
  .check {
    position: absolute;
    top: 15px;
    right: 15px;
    height: 20px;
    display: flex;
    align-items: center;
    z-index: 10;
    cursor: pointer;
    label {
      margin: 0;
    }
    .disabled {
      border-color: #a9a9a9 !important;
    }
    .checked {
      background-color: #7D97FF;
      transition: background-color .2s ease-in;
    }
    img {
      width: 13px;
    }
  }
  .text {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: calc(100% - 180px);
    padding: 25px 30px;
    p {
      margin: 0;
    }
    .name {
      font-weight: bold;
      font-size: 21px;
    }
    .coins {
      margin-left: 5px;
    }
    .value {
      margin-left: 5px;
      font-size: 24px;
      color: ${props => props.theme.main};
      font-weight: bold;
    }
  }
  .image-gallery-icon {
    padding: 30px 0;

    &.image-gallery-right-nav img {
      transform: rotate(180deg);
    }

    img {
      width: 15px;
    }
  }
`;
